import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_LIST_PASSPORTS,
    REQUEST_ADD_PASSPORT,
    REQUEST_UPDATE_PASSPORT_WITH_OAUTH,
    REQUEST_UPDATE_PASSPORT,
    REQUEST_REMOVE_PASSPORT,
    REQUEST_LIST_STORY,
    REQUEST_TENANT_URL,
    REQUEST_TENANT_NAME,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/sapMsgDefinitions";
import { SAPPassportHeader, SAPPassportID } from "userful-chronos-app-common-js/dist/models/integration/sap";
import "./sapMsgReciever";

export const requestListPassports = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSPORTS);
};

export const requestAddPassport = (payload: SAPPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_PASSPORT, payload);
};

export const requestUpdatePassportWithOAuth = (payload: SAPPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT_WITH_OAUTH, payload);
};

export const requestUpdatePassport = (payload: SAPPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT, payload);
};

export const requestRemovePassport = (payload: SAPPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSPORT, payload);
};

export const requestListStory = (paylaod: SAPPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_STORY, paylaod);
};

export const requestTenantURL = (paylaod: SAPPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_TENANT_URL, paylaod);
};

export const requestTenantName = (paylaod: SAPPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_TENANT_NAME, paylaod);
};
